import { useState } from "react"
import { getTodaysDate, getPastDateByMonth } from "../../classes/utils"
export default function DatePicker({ setFilter, setDates }) {
    const [ startDate, setStartDate ] = useState(getPastDateByMonth(1))
    const [ endDate, setEndDate ] = useState(getTodaysDate())
    const startDateHandler = (e) => {
        setStartDate(e.target.value)
        setDates((state) => {
            return {...state, startDate: e.target.value}
        })
    }
    const endDateHandler = (e) => {
        setEndDate(e.target.value)
        setDates((state) => {
            return {...state, endDate: e.target.value}
        })
    }
    return <div className="date-picker flex flex-wrap w-full">
        <div className="flex flex-col text-start w-min-fit w-1/2">
            <label>From:</label>
            <input type="date" className="p-2 text-md rounded-sm bg-input" value={startDate} onChange={startDateHandler}></input>
        </div>
        <div className="flex flex-col text-start w-min-fit w-1/2">
            <label>To:</label>
            <input type="date" className="p-2 text-md ml-1 rounded-sm bg-input" value={endDate} onChange={endDateHandler}></input>
        </div>
    </div>
}